import { VendedorService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";
import { WarningException } from "utils";

export const VendedorManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();
  const buscarPorId = (Id, esLookup) => {
    return VendedorService.buscarPorId(Id, esLookup).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const listado = (where) => {
    return VendedorService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };

  const crear = (usuario) => {
    return validar(usuario).then(() =>
      VendedorService.crear(usuario).then((res) => {
        if (!res.Success) {
          handleException(res);
        }
        return res.Data;
      })
    );
  };

  const actualizar = (usuario) => {
    return validar(usuario).then(() =>
      VendedorService.actualizar(usuario).then((res) => {
        if (!res.Success) {
          handleException(res);
        }
        return res.Data;
      })
    );
  };

  const validar = (vendedor) => {
    return new Promise((res) => res(vendedor)).then((vendedor) => {
      let requiredFields = [];
      if (!vendedor.Nombre) {
        requiredFields.push("Nombre");
      }

      if (vendedor.TelefonoPrincipal) {
        validatePhone(vendedor.TelefonoPrincipal);
      }

      if (vendedor.TelefonoSecundario) {
        validatePhone(vendedor.TelefonoSecundario);
      }

      if (requiredFields.length > 0) {
        throw new WarningException(
          `Los siguientes campos son requeridos: ${requiredFields.join(", ")}.`
        );
      }
    });
  };

  const validatePhone = (phone) => {
    const regex = /^\d{10}$/;

    if (!regex.test(phone)) {
      throw new WarningException("Teléfono no válido");
    }
  };

  const exportar = (where) => {
    return VendedorService.exportar(where).then((res) => {
      return res;
    });
  };

  return {
    buscarPorId,
    listado,
    crear,
    actualizar,
    exportar,
  };
})();
